import React, { useEffect } from 'react';
import ReactPlayer from 'react-player';

import styles from '../../theme/staticpages.module.scss';
import '../../theme/global.scss';
import { Space } from '../../components/utils/utils';
import { variables } from '../../utils/variables';

const TermsAndConditions = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <section className={styles.containerStaticPage}>
      <div className={styles.steps}>
        <p className='bold'>
          TERMENI SI CONDITII PRIVIND UTILIZAREA SOFTWARE-ULUI SIRAR (SaaS)
        </p>
        <Space vertical={variables.verticalSpace} />

        <p>
          <b>Versiunea [1]</b>
          <br></br>
          <b>Data ultime actualizari: [10.12.2021]</b>
        </p>
        <Space vertical={variables.verticalSpace} />
        <h3>
          <p>
            <b>Cititi cu atentie...</b>
          </p>
        </h3>
        <ol type='1'>
          <li>
            <p>
              Va incurajam sa cititi intregul document, pentru ca, odata
              acceptat, va obliga, si doar in conditiile lui puteti sa utilizati
              Software-ul Sirar („<b>Software-ul</b>”).
            </p>
          </li>
          <li>
            <p>In principal, suntem de acord ca:</p>
            <ul>
              <li>
                <p>
                  Serviciile noastre sunt furnizate ca atare, fara nicio
                  garantie explicita sau implicita sau vreo raspundere din
                  partea noastra, cu exceptia raspunderii asumate de noi in mod
                  expres sau impuse de lege;
                </p>
              </li>
              <li>
                <p>
                  Sunteti responsabili de informatiile/datele pe care le stocati
                  prin utilizarea Software-ului, inclusiv de pastrarea unei
                  copii de siguranta a acestora, precum si de activitatea dvs.
                  in legatura cu Software-ul Sirar si afara utilizarii lui. Este
                  exclusa raspunderea noastra pentru faptele sau omisiunile
                  Utilizatorilor;
                </p>
              </li>
              <li>
                <p>
                  Daca aflam ca Software-ul sau serviciile noastre sunt folosite
                  in mod ilegal sau cu incalcarea contractului nostru, va putem
                  intrerupe accesul la acestea, dar va vom instiinta si vom da
                  posibilitatea sa va spuneti punctul de vedere;
                </p>
              </li>
              <li>
                <p>
                  Sectiunea de „Legislatie” a Software-ului are un caracter pur
                  informativ. Desi ne straduim sa o tinem actualizata, aceasta
                  nu constituie o sursa oficiala de informatii sau un portal
                  legislativ. Pentru legislatia la zi, puteti consulta sectiunea
                  relevanta a Monitorului Oficial;
                </p>
              </li>
              <li>
                <p>
                  Din cand in cand, putem schimba acesti termeni si conditii,
                  dar va vom anunta prin e-mail de orice asemenea schimbare.
                </p>
              </li>
              <li>
                <p>
                  Termenii si Conditiile de Utilizare ai Software-ului se
                  completeaza cu Contractul de furnizare a Software-ului,
                  Politica de confidentialitate, Acordul de prelucrare a datelor
                  Personale si Politica de module cookies.
                </p>
              </li>
            </ul>
          </li>
        </ol>
        <h3>
          <p>
            <b>Despre noi si Software-ul Sirar</b>
          </p>
        </h3>
        <ol type='1'>
          <li value='3'>
            <p>
              Suntem SIRAR SOLUTIONS S.R.L., societate de drept roman cu sediul
              in Municipiul Târgovişte, Str. G-RAL MATEI VLĂDESCU, Nr. 1, Bloc
              18, Etaj 2, Apartament 12, Județ Dâmboviţa, avand numar de
              inregistrare J15/346/2021, identificator unic european,
              ROONRC.J15/346/2021, CUI 43852251 (denumita in cele ce urmeaza “
              <b>noi</b>”, „<b>Societatea</b>” sau orice alt termen similar).
            </p>
          </li>
          <li>
            <p>
              {' '}
              Am creat si dezvoltat software-ul Sirar® (denumit in cele ce
              urmeaza „<b>Software-ul</b>” sau “<b>Sirar</b>”) avand ca
              funcționalitati principale monitorizarea de catre instituțiile
              publice inrolate in platforma Sirar („
              <b>Instititutiile publice</b>” sau „<b>Utilizatorii</b>” sau „
              <b>dvs.</b>”) a implementarii masurilor dispuse sau recomandate (“
              <b>Masurile de remediere</b>”) de catre organele de audit si/sau
              control competente, in urma inspectiilor efectuate la asemenea
              institutii publice, precum si monitorizarea stadiului dosarelor de
              instanta prin interogarea portalului{' '}
              <a href='www.just.ro'>www.just.ro</a>
            </p>
          </li>
          <li>
            <p>
              Software-ul poate fi accesat la adresa{' '}
              <a href='www.soft.sirar.ro'>soft.sirar.ro</a>
            </p>
          </li>
          <li>
            <p>
              {' '}
              Prin intermediul Software-ului, conducatorii Institutiilor
              publice, inclusiv conducatorii autoritatilor ierarhic superioare,
              isi pot forma o imagine transparenta si sintetica asupra Masurilor
              de remediere, inclusiv asupra gradului si stadiului implementarii
              acestora de catre persoanele responsabile, ca si asupra
              respectarii termenelor-limita impuse, acolo unde este cazul.
            </p>
          </li>
          <li>
            <p>
              {' '}
              In afara punerii la dispozitie a Software-ului, Societatea nu
              presteaza alte tipuri de servicii prin intermediul Software-ului;
              in mod particular, nu poate fi tinuta responsabila pentru
              activitatea Institutiilor sau a persoanelor autorizate de catre
              acestea prin intermediul Software-ului sau in alte circumstante.
            </p>
          </li>
          <li>
            <p>
              {' '}
              Daca doriti sa luati legatura cu noi, ne puteti transmite un email
              la adresa office@sirar.ro sau ne puteti scrie la adresa de sediu.
            </p>
          </li>
        </ol>
        <h3>
          <p>
            <b>
              Termenii si Conditiile Sirar (T&C) fac parte din contractul dvs.
              cu noi
            </b>
          </p>
        </h3>
        <p>
          <b>
            <u>Documente contractuale si obiect</u>
          </b>
        </p>
        <ol type='1'>
          <li value='9'>
            <p>
              Pentru accesul Software-ul, dvs. incheiati un contract cu
              Societatea, din care fac parte acesti termeni si conditii de
              utilizare a Software-ului (“<b>Termenii si Conditiile</b>” sau “
              <b>T&C</b>”), impreuna cu Politica de Confidentialitate (link),
              Politica de cookies (link) si Acordul de prelucrare a datelor
              personale (link).{' '}
            </p>
          </li>
          <li>
            <p>
              In prealabil accesarii Software-ului, Utilizatorii incheie un
              contract scris de furnizare servicii software cu Societatea („
              <b>Contractul de furnizare a Software-ului</b>”). In cazul in care
              exista contradictii intre Termeni si Conditii si Contractul de
              furnizare a Software-ului, vor prevala dispozitiile Contractului
              de furnizare a Software-ului.
            </p>
          </li>
          <li>
            <p>
              Obiectul acestor T&C il reprezinta oferirea contra-cost a
              dreptului la acces și la utilizarea Software-ului Sirar.
            </p>
          </li>
        </ol>
        <p>
          <b>
            <u>Acceptarea Termenilor si Conditiilor</u>
          </b>
        </p>
        <ol type='1'>
          <li value='12'>
            <p>
              Folosirea Software-ului este posibila doar daca acceptati in mod
              expres documentele contractuale, inclusiv acesti Termeni si
              Conditii, care reglementeaza accesul si utilizarea Software-ului
              Sirar al Utilizatorilor.{' '}
            </p>
          </li>
          <li>
            <p>
              Va recomandam sa salvati acesti Termeni si Conditii ai
              Software-ului (versiunea in vigoare la data crearii contului),
              pentru cazul in care nu le mai puteti accesa ulterior.{' '}
            </p>
          </li>
        </ol>
        <p>
          <b>
            <u>Modificari ale T&C Sirar</u>
          </b>
        </p>
        <ol type='1'>
          <li value='14'>
            <p>
              Din cand in cand, putem modifica acesti T&C ai Software-ului,
              pentru a reflecta modificari ale ale Software-ului, ale
              legislatiei sau ale practicilor noastre interne, etc. Asemenea
              modificari vor fi aplicabile si obligatorii pentru parti, in
              principiu, doar pentru viitor, cu exceptia situatiilor cand legea
              impune ca aceaste modificari sa se aplice retroactiv. Prin
              modificare T&C, se va modifica in mod corespunzator si contractul
              nostru cu dvs.
            </p>
          </li>
          <li>
            <p>
              Orice asemenea modificari vor fi notificate, la adresa de e-mail
              pe care ati pus-o la dispozitie la crearea contului de Utilizator.
            </p>
          </li>
          <li>
            <p>
              In situatia in care nu sunteti de acord modificarile T&C, ne
              puteti transmite obiectiunile dvs. justificate in termen de 5 zile
              de comunicarea modificarilor operate de noi. Ne vom stradui sa le
              luam in considerare, fara a fi obligati a fi de acord cu dvs.{' '}
            </p>
          </li>
        </ol>
        <h3>
          <p>
            <b>Contul de Utilizator. Activare. Manualul de utilizare.</b>
          </p>
        </h3>
        <ol type='1'>
          <li value='17'>
            <p>
              Exista doua tipuri de cont de Utilizator: primar si secundar. Daca
              nu se precizeaza altfel, orice referire din prezentii Termeni si
              Conditii la „contul de Utilizator” va fi o referire atat la contul
              primar, cat si la cele secundare, daca exista.
            </p>
          </li>
          <li>
            <p>
              Contul primar de Utilizator este cel initial creat de catre noi in
              numele dvs. si trebuie activat, conform celor de mai jos. Ulterior
              activarii contului primar, se pot crea/activa mai multe conturi
              secundare care vor fi asociate contului de Utilizator primar.{' '}
            </p>
          </li>
          <li>
            <p>
              Contul primar este destinat conducatorului Institutiei publice,
              care supervizeaza implementarea Masurilor de remediere. Prin
              intermediul contului primar se pot urmari Masurile de remediere de
              la nivelul intregii Institutii publice. De asemenea, utilizatorul
              contului primar are posibilitatea crearii de conturi secundare.
            </p>
          </li>
          <li>
            <p>
              Conturile secundare sunt destinate angajatilor subordonati care
              sunt desemnati pentru implementarea Masurilor de remediere.{' '}
            </p>
          </li>
          <li>
            <p>
              Contul primar de Utilizator va fi creat de catre noi, folosind
              datele de contact puse la dispozitie de catre dvs. prin Contractul
              de furnizare a Software-ului.{' '}
            </p>
          </li>
          <li>
            <p>
              Veti fi notificat de crearea contului de utilizator prin e-mail si
              vi se va cere sa va activati contul, precum si sa confirmati in
              mod expres urmatoarele:{' '}
            </p>
            <ol type='a'>
              <li>
                <p>
                  In calitate de reprezentant al Utilizatorului, persoana care
                  creeaza contul („<b>Reprezentantul Utilizatorului</b>”)
                  declara ca are capacitatea de reprezenta Utilizatorul;
                </p>
              </li>
              <li>
                <p>
                  <b>Reprezentantul Utilizatorului</b> accepta in mod expres
                  Termenii si Conditiile de Utilizare ai Software-ului Sirar;
                </p>
              </li>
              <li>
                <p>
                  <b>Reprezentantul Utilizatorului</b> exprima consimtamantul
                  expres al Utilizatorului pentru a primi mesaje de marketing
                  din partea Sirar Solutions SRL, prin orice canale, inclusiv
                  prin e-mail.
                </p>
              </li>
              <li>
                <p>
                  <b>Reprezentantul Utilizatorului</b> consimte expres la
                  prelucrarea datelor personale in conditiile Acordului de
                  prelucrare a datelor personale, precum si ale Politicii de
                  cookies.
                </p>
              </li>
              <li>
                <p>
                  <b>Reprezentantul Utilizatorului</b> a citit si intelege
                  Politica de confidentialitate a Software-ului.
                </p>
              </li>
            </ol>
          </li>
          <li>
            <p>
              Ulterior activarii contului de Utilizator puteti sa modificati
              datele dvs. de contact sau de identificare, daca este cazul, prin
              accesarea meniului „Administrare interna”. De asemenea puteti
              adauga institutia ierarhic superioara (ordonator de credite) la
              lista de persoane care sunt notificare de implementarea Masurilor
              de remediere.
            </p>
          </li>
          <li>
            <p>
              Odata accesat contul de Utilizator, aveti posibilitatea sa
              incarcati documentele de control relevante (rapoarte si decizii
              ale Curtii de Conturi, situatii privind achizitiile publice -
              anexe ale regulamentului privind organizarea si desfasurarea
              activitatilor specifice Curtii de Conturi -, rapoarte de audit
              intern, etc.), documentele ce atesta implementarea Masurilor de
              remdiere, precum si sa stabiliti notificari si sa urmariti
              calendarul Masurilor de implementare. Pentru mai multe detalii cu
              privire la modul concret de utilizare a Software-ului, va rugam sa
              consultati{' '}
              <a href='https://soft.sirar.ro/tutorial'>
                Manualul nostru de utilizare.
              </a>
            </p>
          </li>
          <li>
            <p>
              Reprezentantul Utilizatorului care acceseaza Platfroma, trebuie sa
              fie un angajat sau o alta persoana autorizata a Utilizatorului.{' '}
            </p>
          </li>
          <li>
            <p>
              Ne rezervam dreptul de a solicita informatii si documente
              suplimentare pentru a verifica identitatea Utilizatorilor sau
              reprezentantilor acestor si indeplinirea conditiilor de mai sus,{' '}
              <b>
                <u>fara a ne asuma aceasta obligatie</u>
              </b>
              . In cazul in care aceste informatii/documente nu sunt oferite
              putem sa refuzam/suspendam contul de Utilizator.
            </p>
          </li>
          <li>
            <p>
              Contul apartine doar Utilizatorului inregistrat si nu il puteti
              transfera, fara acordul nostru scris. Nu trebuie sa autorizati sau
              sa permiteti oricarei alte persoane sa il foloseasca, cu exceptia
              reprezentantilor autorizati. Avem dreptul sa va suspendam/inchidem
              contul de Utilizator oricand avem motive sa credem ca este folosit
              ilegal sau contrar acestor Termeni si Conditii.
            </p>
          </li>
          <li>
            <p>
              Utilizarea de date false sau fara acordul personei in cauza,
              pentru crearea de conturi de Utilizator este interzisa si poate
              atrage suspendarea/incetarea furnizarii serviciilor din prezenta,
              precum si toate consecintele legale ce decurg din aceste fapte.
            </p>
          </li>
        </ol>
        <h3>
          <p>
            <b>Date cu privire la Utilizator. Accesul la aceste date</b>
          </p>
        </h3>
        <ol type='1'>
          <li value='29'>
            <p>
              La crearea contului de Utilizator vor fi introduse urmatoarele
              date (denumite si „<b>Datele Utilizatorului</b>”): e-mailul de
              contact si parola, denumirea, codul de identificare fiscala a
              persoanei juridice, datele de identificare ale reprezentantului
              persoanei juridice, adresa de sediu, telefonul.
            </p>
          </li>
          <li>
            <p>
              Folosind setarile din contul de Utilizator puteti, printre altele,
              sa va completati informatiile, sa corectati eventuale erori ivite
              cu ocazia introducerii datelor si sa ne cereti sa schimbam sau sa
              va reamintim parola.
            </p>
          </li>
          <li>
            <p>
              Aveti obligatia de a pastra confidentialitatea datelor de cont
              (user si parola) si raspunderea pentru gestionarea accesarii
              contului si pentru activitatea derulata prin intermediul acestui
              cont de Utilizator.
            </p>
          </li>
          <li>
            <p>
              Datele introduse de catre Utilizator in cursul utilizarii
              Software-ului, inclusiv datele personale, pe care dvs., le
              introduceti sau le faceti accesibile in cadrul Software-ului („
              <b>Date generate de Utilizator</b>” sau „
              <b>Datele generate de dvs.</b>”), pentru a beneficia de
              functionalitatile acesteia sunt enumerate mai jos cu titlu
              exemplificativ:
            </p>
            <ol type='a'>
              <li>
                <p>
                  Datele referitoare la reprezentantii persoane fizice ale
                  Utilizatorilor – acestea pot include: nume, prenume, adresa de
                  e-mail, alte date de identificare.
                </p>
              </li>
              <li>
                <p>
                  La datele de mai sus se adauga si o serie de informatii si
                  date, inclusiv date personale, care va permit utilizarea
                  Software-ului sau care au legatura cu aceasta (cum ar fi
                  informatiile cuprinse in rapoartele de audit sau rapoartele de
                  control ale Curtii de Conturi).
                </p>
              </li>
            </ol>
          </li>
          <li>
            <p>
              Pentru detalii suplimentare cu privire la utilizarea datelor
              personale ale Utilizatorului, inclusiv a Datelor generate de
              utilizator, a se vedea Politica de confidentialitate.
            </p>
          </li>
        </ol>
        <h3>
          <p>
            <b>Conținutul încărcat în Software-ul. Securitatea Datelor</b>
          </p>
        </h3>
        <ol type='1'>
          <li value='34'>
            <p>
              Documentele si informatiile administrate prin intermediul
              Software-ului sunt sub controlul exclusiv al Instituțiilor publice
              care le încarcă în Platformă sau le generează prin intermediul
              Software-ului.{' '}
            </p>
          </li>
          <li>
            <p>
              Instituțiile poartă răspunderea integrală pentru obținerea tuturor
              autorizațiilor și avizelor necesare pentru stocarea și
              managementul documentelor prin intermediul Software-ului.
            </p>
          </li>
          <li>
            <p>
              In mod particular, se atrage atenția asupra documentelor ce
              constituie{' '}
              <b>
                <u>
                  secret de serviciu, secret de stat sau informații clasificate,
                  în sensul legislației specifice.
                </u>
              </b>{' '}
              Acestea nu pot fi încărcate sau administrate prin intermediul
              Software-ului. În cazul în care sesizăm că încălcați această
              interdicție (deși nu ne obligăm să monitorizăm conținutul stocat
              prin intermediul Software-ului), avem dreptul de a vă suspenda
              accesul la Software de și de a cere rezilierea Contractului de
              furnizare a Software-ului.
            </p>
          </li>
          <li>
            <p>
              Orice răspundere a Societății este exclusă pentru lipsa unor
              asemenea autorizații sau permise sau pentru încălcarea
              reglementărilor ce se aplică documentelor pe care le gestionați
              prin intermediul Software-ului.
            </p>
          </li>
          <li>
            <p>
              Infrastructura de hosting a Sirar este asigurata de catre{' '}
              <a href='https://aws.amazon.com'>Amazon Web Services</a>, sau pe
              viitor una similara ca funcționalități (Societatea își rezervă
              dreptul de a migra la orice moment către alte servicii sau
              platforme existente in piață).{' '}
            </p>
          </li>
          <li>
            <p>
              Utilizatorul va face o copie de siguranță externă pentru toate
              datele, informațiile, bazele de date, etc. transmise, găzduite,
              create, dezvoltate pe în cadrul Software-ului sau pe care le-a
              transmis în orice modalitate către Software-ul. Societatea nu va
              putea fi ținut responsabila pentru accesul neautorizat, pierderea,
              ștergerea și/sau alterarea acestor date, informații, baze de date
              ale Utilizatorului din culpa Utilizatorului sau a unor terțe
              părți, indiferent de factorii și de motivul din care acestea
              survin. Utilizatorul are obligația să verifice integritatea
              acestor date, etc. și a copiilor de siguranță externe.
            </p>
          </li>
        </ol>
        <h3>
          <p>
            <b>Comunicarea cu Utilizatorii</b>
          </p>
        </h3>
        <ol type='1'>
          <li value='40'>
            <p>
              Sunteti de acord ca noi sa folosim adresa de e-mail folosita la
              crearea contului de Utilizator pentru a comunica cu dvs. la orice
              moment, de aceea sunteti incurajati sa va verificati in mod
              periodic adresa de e-mail, pentru eventuale comunicari din partea
              noastra.{' '}
            </p>
          </li>
          <li>
            <p>Dvs. ne puteti contacta prin modalitatea prevazuta la art. 8.</p>
          </li>
          <li>
            <p>
              Va putem transmite prin e-mail sau direct prin intermediul
              Software-ului, mesaje privind mentenanța sau alte aspecte
              administrative (de exemplu: întreruperea temporară a serviciului,
              apariția unor noi funcționalități, etc.).
            </p>
          </li>
          <li>
            <p>
              De asemenea, ocazional, vă putem transmite mesaje de marketing, în
              condițiile legii. Aveți posibilitatea, potrivit legii să
              solicitați să nu mai primiți asemenea mesaje, transmițându-ne un
              e-mail la adresa de contact de mai sus.{' '}
            </p>
          </li>
        </ol>
        <h3>
          <p>
            <b>Preturi. Plati</b>
          </p>
        </h3>
        <ol type='1'>
          <li value='44'>
            <p>
              Accesul la Software-ul este conditionat de plata pretului de
              furnizare a Software-ului prevazut de Contractul de furnizare a
              Software-ului.
            </p>
          </li>
          <li>
            <p>
              Platile catre Societate vor fi facute in suma neta. Cu ocazia
              efectuarii de plati catre Societate este posibil sa fie percepute
              comisioane de catre terte parti (cum ar fi: comisioane bancare
              etc.). Utilizatorul va fi obligat sa suporte toate aceste
              cheltuieli sau sume suplimentare percepute, fara a diminua in
              vreun fel sumele datorate Societatii.
            </p>
          </li>
          <li>
            <p>
              Fiecare Parte este responsabila de respectarea obligatiilor
              fiscale sau de alta natura pe care legea le stabileste in sarcina
              sa.
            </p>
          </li>
        </ol>
        <h3>
          <p>
            <b>Disponibilitatea Software-ului </b>
          </p>
        </h3>
        <ol type='1'>
          <li value='47'>
            <p>
              Software-ul este gazduita pe infrastructura unor furnizori
              specializati de servicii de hosting (in prezent,{' '}
              <a href='https://aws.amazon.com'>Amazon Web Services</a>)
              („Furnizorul de hosting”) si este in consecinta dependenta de
              disponibilitatea serviciului acestor furnizori. Termenii si
              conditiile de furnizare a serviciilor de hosting sunt disponibile
              la adresa{' '}
              <a href='https://aws.amazon.com/service-terms/'>
                https://aws.amazon.com/service-terms/
              </a>{' '}
            </p>
          </li>
          <li>
            <p>
              Cu exceptia situatiilor agreate expres, Societatea nu isi asuma
              disponibilitatea Software-ului Sirar prin reteaua publica de
              internet (uptime), decat in limita accesibilitatii oferite de
              Furnizorul de hosting, conform termenilor si conditiilor
              Furnizorului de hosting, dupa cum sunt disponibile din timp in
              timp.{' '}
            </p>
          </li>
          <li>
            <p>
              Se pune in vedere Utilizatorului faptul ca Software-ul Sirar este
              oferit ca atare, fara nicio garantie expresa sau implicita si este
              exclusa orice raspundere a Societatii pentru orice prejudicii
              rezultand in legatura cu utilizarea Software-ului, in cea mai mare
              masura permisa de lege.{' '}
            </p>
          </li>
        </ol>
        <h3>
          <p>
            <b>Proprietate intelectuala</b>
          </p>
        </h3>
        <ol type='1'>
          <li value='50'>
            <p>
              Societatea detine toate drepturile de proprietate intelectuala
              asupra Software-ului, asupra domeniului sirar.ro, website-ului
              sirar.ro („<b>website-ul Sirar</b>”), precum si asupra oricaror
              versiuni ale acestora, inclusiv asupra codului-sursa, codului
              obiect, interfetei grafice, continutului postat in cadrul
              Software-ului de catre Societate.
            </p>
          </li>
          <li>
            <p>
              Este interzisa orice actiune asupra sau in legatura cu Software-ul
              care ar putea aduce atingere drepturilor de proprietate
              intelectuala ale Societatii cum ar fi: copierea in tot sau in
              parte a Software-ului, distribuirea, alterarea, compilarea,
              modificarea acesteia sau a website-ului Sirar, etc., fara acordul
              prealabil scris al Societatii.
            </p>
          </li>
          <li>
            <p>
              Marca Sirar® este marca inregistrata la nivel national pe numele
              titularului Sirar Solutions SRL. Folosirea marcii Sirar® fara
              acordul titularului este interzisa.
            </p>
          </li>
          <li>
            <p>
              Nu aveti voie sa folositi in orice mod - fara acordul nostru scris
              si prealabil – oricare din elementele sau continutul de pe
              website-ul Sirar (fotografii, text, elemente grafice sau video,
              imagini, design, layout, logo-uri, marci inregistrate sau
              neinregistrate, simboluri comerciale, software, continut
              multimedia, etc.); acestea sunt proprietatea noastra sau a
              titularilor legitimi, si utilizarea lor fara acordul titularilor
              lor va atrage consecintele prevazute de legislatia aplicabila.
            </p>
          </li>
          <li>
            <p>
              Utilizatorii Software-ului pastreaza toate drepturile asupra
              continutului incarcat in Software-ul, in special asupra Datelor
              generate de Utilizator (a se vedea art. 32 de mai sus). Continutul
              încarcat pe/prin Software-ul va respecta Regulile de Conduita
              prevazute de T&C al Software-ului, in caz contrar, Societatea isi
              rezerva dreptul de a suspenda contul de Utilizator sau de a-l
              dezactiva definitiv.
            </p>
          </li>
        </ol>
        <h3>
          <p>
            <b>Folosirea testimonialelor reprezentantilor Utilizatorilor</b>
          </p>
        </h3>
        <ol type='1'>
          <li value='55'>
            <p>
              Ocazional, va putem solicita sa ne transmiteti parerea dvs. si/sau
              a reprezentantilor Utilizatorilor cu privire la utilizarea
              Software-ului, inclusiv prin postarea de citate, imagini statice
              sau inregistrari audio-video cu reprezentantii Utilizatorilor („
              <b>Testimoniale</b>”).
            </p>
          </li>
          <li>
            <p>
              Prin prezentul va dati acordul folosirii Testimonialelor prin
              postarea pe website-ul Sirar sau in orice material de marketing al
              Societatii, fara nici o alta pretentie la adresa Sirar sau a
              oricarei alte terte parti. Licenta de utilizare a Testimonialelor
              este una revocabila, acordata cu titlu gratuit, perpetuu si
              acordata la nivelul intregului mapamond.
            </p>
          </li>
          <li>
            <p>
              Puteti solicita oricand stoparea folosirii Testimonialelor de
              catre Sirar, contactandu-ne in modalitatile prevazute la art. 8
              din acesti T&C. Aceasta nu aduce atingere oricaror drepturi pe
              care vi le recunoaste legea, in special drepturile legate de
              protectia datelor cu caracter personal. In acest scop, va rugam sa
              consultati Politica noastra de confidentialitate (link).
            </p>
          </li>
        </ol>
        <h3>
          <p>
            <b>Reguli de conduita in utilizarea Software-ului</b>
          </p>
        </h3>
        <ol type='1'>
          <li value='58'>
            <p>
              Utilizarea Software-ului trebuie sa respecte cerintele legislatiei
              si sa nu incalce drepturile nimanui.{' '}
            </p>
          </li>
          <li>
            <p>
              In acest scop, Utilizatorii Software-ului vor respecta urmatoarele
              reguli de conduita („<b>Regulile de Conduita</b>”):
            </p>
            <ol type='a'>
              <li>
                <p>
                  Vor folosi Software-ul doar potrivit acestor Termeni si
                  Condiiti si legii aplicabile;
                </p>
              </li>
              <li>
                <p>
                  Nu vor incarca si nu vor folosi in cadrul Software-ului
                  continut ilegal, daunator, ofensator, rasist, xenofob sau
                  imoral. Prin continut ilegal se intelege orice continut care
                  incalca sau carui incarcare incalca un act normativ sau un
                  contract sau care incalca in orice fel drepturile unor terte
                  parti;
                </p>
              </li>
              <li>
                <p>
                  Nu vor utiliza Software-ul intr-o modalitate care sa
                  deterioreze, dezactiveze, supraincarce sau sa impiedice
                  utilizarea Software-ului sau care sa interfereze in mod
                  neautorizat cu interactiunea celorlalti Utilizatori cu
                  Software-ul;
                </p>
              </li>
              <li>
                <p>
                  Nu vor intreprinde activitati precum decompilarea sau copierea
                  prin orice metode, inclusiv prin reverse engineering a
                  Software-ului;
                </p>
              </li>
              <li>
                <p>
                  Nu vor folosi Software-ul pentru activitati ilegale, inclusiv
                  phishing, transmiterea de publicitate neautorizata sau
                  ilegala, continut adult, spam, junk mail, chain letters sau
                  orice alta forma de mesagerie in masa;
                </p>
              </li>
              <li>
                <p>
                  Nu vor folosi Software-ul in modalitati care incalca
                  proprietatea intelectuala sau alte drepturi, secrete
                  comerciale sau confidentialitatea unor terte parti;
                </p>
              </li>
              <li>
                <p>
                  Nu vor folosi Software-ul pentru a transmite materiale care
                  contin adware, malware, spyware, virusi informatici sau orice
                  cod malitios sau care este destinat sa intrerupa, distruga sau
                  sa limiteze functionalitatea unei aplicatii informatice sau a
                  unui echipament;
                </p>
              </li>
              <li>
                <p>
                  In general nu vor folosi Software-ul intr-un mod nerezonabil,
                  abuziv sau ilegal.
                </p>
              </li>
            </ol>
          </li>
        </ol>
        <h3>
          <p>
            <b>
              Incetarea contractului cu Utilizatorii. Restrictionarea,
              suspendarea si sistarea accesului{' '}
            </b>
          </p>
        </h3>
        <ol type='1'>
          <li value='60'>
            <p>
              Sub rezerva respectarii obligatiilor contractuale, ne vom stradui,
              fara a garanta, faptul ca Utilizatorul va avea acces continuu la
              Software, pe durata Contractului de furnizare a Software-ului.
            </p>
          </li>
          <li>
            <p>
              Putem alege sa incetam contractul cu dvs., printr-o simpla
              notificare transmisa pe adresa de e-mail de contact, cu un preaviz
              de 5 zile lucratoare.{' '}
            </p>
          </li>
          <li>
            <p>
              Societatea va putea sa suspende si, ulterior, sa elimine complet
              accesul Utilizatorilor la Software daca Utilizatorul incalca legea
              sau acesti T&C. Dupa suspendarea accesului la Software, Societatea
              va notifica Utilizatorului in cauza motivul suspendarii, acordand
              un termen rezonabil pentru ca Utilizatorul sa-si exprime punctul
              de vedere/apararea, inainte de a elimina, daca este cazul, complet
              accesul la Software-ul.{' '}
            </p>
          </li>
          <li>
            <p>
              In situatia incetarii din orice motiv a T&C ale Software-ului,
              Utilizatorii vor avea la dispozitie un termen de gratie de 30 de
              zile pentru a prelua informatiile existente pe Software-ul cu
              privire la activitatea acestora („<b>Datele Utilizatorului</b>”).
              La expirarea termenului de gratie mai sus mentionat, daca acesta
              nu este prelungit de catre Societate, Datele Utilizatorului vor
              deveni inaccesibile pentru Utilizator si vor putea fi eliminate,
              la discretia Societatii.
            </p>
          </li>
          <li>
            <p>
              Dispozitiile prevazute in art. 63 nu aduc in niciun fel atingere
              drepturilor persoanelor fizice prevazute in special de legislatia
              din domeniul datelor cu caracter personal sau de alte acte
              normative.{' '}
            </p>
          </li>
        </ol>
        <h3>
          <p>
            <b>Raspunderea noastra</b>
          </p>
        </h3>
        <ol type='1'>
          <li value='65'>
            <p>
              Orice referire la noi sau Societate, din aceasta sectiune privind
              Raspunderea noastra ii include si pe directorii, administratorii,
              angajatii si reprezentantii nostri, care vor beneficia, in cea mai
              mare masura permisa de lege de orice limitare sau exonerare de
              raspundere prevazuta de prezenta
            </p>
          </li>
          <li>
            <p>
              In cea mai mare masura permisa de lege, raspunderea noastra totala
              fata de dvs. in legatura cu utilizarea in orice fel a
              Software-ului va fi limitata la valoarea pretului platit pentru
              serviciile noastre pe perioada a doua luni contractuale.{' '}
            </p>
          </li>
          <li>
            <p>
              In orice caz, Societatea nu va putea fi tinuta raspunzatoare decat
              in cazurile unor prejudicii cauzate in mod direct, din culpa grava
              sau cu intentie, cu exceptia cazurilor prevazute expres de lege.
              Este exclusa raspunderea pentru orice prejudiciu indirect (cum ar
              fi, dar fara a se limita la: beneficiul pierdut, pierderea unor
              oportunitati etc.).
            </p>
          </li>
          <li>
            <p>
              Fara a aduce atingere celor de mai sus, nu suntem raspunzatori
              fata de dvs. in special daca:
            </p>
            <ul>
              <li>
                <p>
                  Nu ne putem indeplini la timp sau integral sau ne indeplinim
                  cu intarziere vreo obligatie fata de dvs., cand acest lucru
                  este cauzat de evenimente sau circumstante ce nu tin de
                  controlul nostru (de exemplu: disfunctionalitati tehnice ale
                  furnizorilor, orice caz de forta majora sau caz fortuit,
                  etc.);
                </p>
              </li>
              <li>
                <p>In alte cazuri exprese prevazute de lege.</p>
              </li>
            </ul>
          </li>
        </ol>
        <h3>
          <p>
            <b>Sesizari si reclamatii</b>
          </p>
        </h3>
        <ol type='1'>
          <li value='69'>
            <p>
              Daca aveti nelamuriri sau reclamatii, va rugam sa ne contactati
              într-una din modalitățile prevăzute la art. 8.
            </p>
          </li>
          <li>
            <p>
              Intenționăm să soluționăm intern orice eventuala sesizare sau
              reclamație în termen de 30 de zile de la recepționarea acesteia
              (cu exceptia cazului in care legea ne impune un alt termen),
              urmand sa va informam in scris cu privire la decizia luata.{' '}
            </p>
          </li>
          <li>
            <p>
              Iar daca aveti motive sa credeti ca v-am incalcat drepturile,
              puteti sa va adresati instantelor competente.{' '}
            </p>
          </li>
        </ol>
        <h3>
          <p>
            <b>Soluționarea disputelor și a litigiilor</b>
          </p>
        </h3>
        <ol type='1'>
          <li value='72'>
            <p>
              Dorim să rezolvăm amiabil orice neințelegere ce ar putea interveni
              între noi și dvs. privind acești Termeni și Condiții.{' '}
            </p>
          </li>
          <li>
            <p>
              Dar dacă nu vom putea ajunge la o rezolvare amiabila, litigiul va
              fi soluționat de instanțele competente de la sediul Societatii.
              Legea română este legea aplicabila.
            </p>
          </li>
        </ol>
        <h3>
          <p>
            <b>Alte detalii utile</b>
          </p>
        </h3>
        <ol type='1'>
          <li value='74'>
            <p>
              Website-ul poate conține link-uri către alte website-uri; dvs. le
              folosiți pe risc propriu și vă încurajăm să citiți cu atenție
              termenii lor de utilizare, deoarece noi nu putem fi ținuți
              responsabili pentru conținutul acestor website-uri sau pentru
              produsele sau serviciile pe care le oferă.
            </p>
          </li>
          <li>
            <p>
              Putem oricând sa cedăm acest contract unei alte părți, cu
              informarea dvs. scrisă (de exemplu, în cazul în care vindem sau
              cedăm Software-ul. De asemenea, putem oricând să subcontractăm
              catre un terț anumite servicii, cu informarea dvs., dar fără a fi
              necesar acordul dvs.
            </p>
          </li>
        </ol>
      </div>
    </section>
  );
};

export default TermsAndConditions;
